<div class="select select--pristine select--bottom select--touched">
  <div class="virtual-list-container select__dropdown-panel select--bottom select__dropdown-panel--open">
    <div class="select__panel-header-input" *ngIf="headerVisible">
      <div class="flex flex--middle" style="position: relative">
        <input
          #searchInput
          type="text"
          class="textbox set-input-padding"
          [placeholder]="searchLabel | translate"
          [(ngModel)]="filterText"
          (keyup.enter)="!enableInternalSearch && querySearchStr()"
          (ngModelChange)="enableInternalSearch && filterTextChange()"
          dir="auto"
        />
        <div class="filter__icon">
          <div class="filter__icon u-mr---" *ngIf="!loading && !!filterText" (click)="removeFilter()">
            <svg-icon
              style="height: 1.6rem"
              name="ico-close-16"
              [svgStyle]="{ 'width.px': '16', 'height.px': '16', fill: 'currentColor' }"
            ></svg-icon>
          </div>
          <div *ngIf="loading" class="filter__icon u-mr---">
            <wfm-spinner size="16"></wfm-spinner>
          </div>
          <div class="svg-icon__container" *ngIf="enableInternalSearch">
            <svg-icon
              style="height: 1.6rem"
              [name]="searchIcon"
              [svgStyle]="{ 'width.px': '16', 'height.px': '16', fill: 'currentColor' }"
            ></svg-icon>
          </div>
          <div class="svg-icon__container" *ngIf="!enableInternalSearch" (click)="querySearchStr()">
            <svg-icon
              style="height: 1.6rem"
              name="ico-search-16"
              [svgStyle]="{ 'width.px': '16', 'height.px': '16', fill: 'currentColor' }"
            ></svg-icon>
          </div>
        </div>
      </div>
      <div *ngIf="items && items.length > 0" class="flex flex--row flex--nowrap flex--justify flex--middle u-mt- u-mh---">
        <label for="show-selected" class="checkbox u-mb0">
          <input [(ngModel)]="showSelected" *ngIf="isShowSelected" (ngModelChange)="showSelectedChange()"
                 name="showSelected" id="show-selected" type="checkbox" class="checkbox__input">
          <span *ngIf="isShowSelected" class="checkbox__label">{{ 'core.label.showSelected' | translate }}</span>
        </label>
        <div>
          <a [routerLink]=""  class="u-pl"
             (click)="selectAll()">
            <span>{{ 'core.label.selectAll' | translate }}</span>
          </a>
          <a [routerLink]="" class="u-pl"
             (click)="deselectAll()">
            <span>{{ 'core.label.deselectAll' | translate }}</span>
          </a>
        </div>
      </div>
    </div>
    <div *ngIf="items &&  items.length > 0"  class="virtual-list-scroll-container list-style1__items select__dropdown-panel-items">
      <cdk-virtual-scroll-viewport itemSize="50"
                                   class="virtual-list-body no-scroll-scrollable"
                                   (scroll)="scrollHandler($event)"
                                   (wheel)="onWheel($event)"
                                   (error)="errorNotify.emit($event)">
        <div class="flex flex--col">
          <div  *cdkVirtualFor="let item of displayedItems; index as rowIndex"
                (click)="!disableByField || !item[disableByField] ? toggleSelect(item) : null"
                [class.disabled]="disableByField && item[disableByField]"
                [style.max-height.px]="rowHeight"
                [style.min-height.px]="rowHeight"
                [class.list-style1__item--selected]="selectedItemsMap.get(item) !== undefined"
                class="list-style1__item flex flex--row flex--middle" id="virtual-item-{{rowIndex}}">
            <svg-icon
              style="height: 1.6rem"
              name="ico-checkbox-component-16"
              [svgStyle]="{ 'width.px': '16', 'height.px': '16', fill: 'currentColor' }"
              [applyClass]="true"
              svgClass="swaplist__icon list-style1__item-checkmark"
            >
            </svg-icon>
            <div class="list-style1__item-label text-ellipsis no-selectable"
                 [overflowOnly]="true"
                 [tooltip]="!!labelField ? item[labelField] : item">
              {{ !!labelField ? item[labelField] : item }}
            </div>
          </div>
        </div>
      </cdk-virtual-scroll-viewport>
      <wfm-scrollbar
        *ngIf="verticalScrollSize > verticalOffsetSize && verticalOffsetSize"
        orientation="vertical"
        [offsetSize]="verticalOffsetSize"
        [scrollSize]="verticalScrollSize"
        [arrowIncrement]="rowHeight"
        [position]="verticalScrollPosition"
        (positionChangeEnded)="verticalScrollPositionChange($event)"
      >
      </wfm-scrollbar>
    </div>
  </div>
</div>
